import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { jsonParser } from "../../../utils/helpers";
import { Box, Skeleton } from "@mui/material";

export default function PresentationItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const presentation = props.presentation;

  const [thumbnail, setThumbnail] = useState(false);

  useEffect(() => {
    let thumb = null;
    const json = jsonParser(presentation?.json ? presentation.json : {});

    if (json?.thumbnail?.field_media_image) {
      thumb = json.thumbnail?.field_media_image;
      setThumbnail(thumb);
    } else {
      if (presentation.slides.length > 0) {
        const slide_json = jsonParser(presentation.slides[0]?.slide_json);

        if (slide_json?.reveal?.slideThumbnail?.field_media_image) {
          thumb = slide_json?.reveal?.slideThumbnail?.field_media_image;
        } else {
          thumb = `${system.filesystem_root}/${system.subdomain}/presentations/${presentation.id}/${presentation.id}/thumbnails/slide_${presentation.slides[0].id}_thumbnail.jpg`;
        }

        setThumbnail(thumb);
      }
    }
  }, [props.presentation]);

  return (
    <div
      className={`presentation-item ${
        props.selectedPresentations.filter((item) => {
          return item.id === presentation.id;
        }).length > 0
          ? "selected"
          : ""
      }`}
      onClick={() => {
        if (
          props.selectedPresentations.filter((item) => {
            return item.id === presentation.id;
          }).length > 0
        ) {
          props.removeSelectedPresentationItem(presentation);
        } else {
          props.addSelectedPresentationItem(presentation);
        }
      }}
    >
      {props.selectedPresentations.filter((item) => {
        return item.id === presentation.id;
      }).length > 0 && <div className="selected-presentation-item-marker"></div>}

      {props.selectedPresentations.filter((item) => {
        return item.id === presentation.id;
      }).length > 0 && (
        <svg
          className="selected-presentation-item-marker-check"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="CheckIcon"
        >
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      )}
      <div className="presentation-item-image">
        {thumbnail ? (
          <img src={thumbnail} onError={() => setThumbnail(false)} />
        ) : (
          <img src="./assets/placeholder.jpg" />
        )}
      </div>
      <div className="presentation-item-title">
        {presentation.title.length > 35 ? presentation.title.slice(0, 35) + "..." : presentation.title}
      </div>
      <div className="presentation-item-id">{presentation.id}</div>
    </div>
  );
}
